const actions = {
  async getData({ dispatch }, reportKey) {
    return dispatch('tools/setView', reportKey, { root: true })
  },
}

export default actions
